export function normalizarTema(valor) {
  return valor === "escuro" ? "escuro" : "claro";
}

export const configuracaoFonte = {
  minimo: 80,
  maximo: 130,
  passo: 10,
  padrao: 100,
};

export const configuracaoLuminosidade = {
  minimo: 70,
  maximo: 130,
  passo: 5,
  padrao: 100,
};

export function normalizarLuminosidade(valor) {
  const { minimo, maximo, passo, padrao } = configuracaoLuminosidade;
  if (typeof valor !== "number" || !Number.isFinite(valor)) return padrao;
  return Math.max(minimo, Math.min(maximo, Math.round(valor / passo) * passo));
}
